import { type FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import { FormFields, GraphsFlowChartDown, PieChart } from '@segment/matcha/components/Icons/Brandbook'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Why Segment`,
  elements: [
    {
      icon: FormFields,
      heading: `Real-time, comprehensive customer insights`,
      description: `Make the most of your customer data using Segment for real-time analytics and predictive modeling. Our platform ensures that every decision is backed by up-to-the-minute data, enabling you to stay ahead in delivering personalized customer experiences.`,
    },
    {
      icon: GraphsFlowChartDown,
      heading: `Simplify data science with CustomerAI Predictions`,
      description: `Leverage CustomerAI Predictions to simplify data science for your marketing team. Easily predict behaviors, fostering intelligent, predictive strategies and campaigns that proactively enhance growth and customer satisfaction.`,
    },
    {
      icon: PieChart,
      heading: `Unify customer data for strategic decision-making`,
      description: `Break down data silos with Segment's unified customer profiles and transform fragmented   customer data into a single, coherent view—empowering your teams to make strategic, data-driven decisions.`,
    },
  ],
}

const WhySegment: FC = () => {
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
        </Section.Copy>

        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 3 }}>
            {copy.elements.map(({ icon: Icon, heading, description }) => (
              <FeatureBoxBase key={heading} headerPosition="top" alignment="left">
                <FeatureBox.Header>
                  <StyledIconWrapper variant="circle" elevation={1}>
                    <Icon size="large" />
                  </StyledIconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{heading}</FeatureBox.Title>
                  <FeatureBox.Text variant="pMedium">{description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const StyledIconWrapper = styled(IconWrapper)`
  width: 64px;
  height: 64px;
  padding: 6px;
`

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSection = styled(SectionBase)`
  max-width: 1280px;
`

export default WhySegment
